import React from "react";
import CounterAreaThreeItem from "./CounterAreaThreeItem";

const CounterAreaThree = () => {
  const counter_items = [
    {
      src: "/img/icon/inner_counter_icon01.png",
      titles: ["Tevreden", "Klanten"],
      amount: 150,
    },
    {
      src: "/img/icon/inner_counter_icon02.png",
      titles: ["Projecten", "Afgerond"],
      amount: 100,
    },
    {
      src: "/img/icon/inner_counter_icon03.png",
      titles: ["Jaren", "Ervaring"],
      amount: 23,
    },
    {
      src: "/img/icon/inner_counter_icon04.png",
      titles: ["Beoordeling", "Klanten"],
      amount: 10,
    },
  ];

  return (
    <section className="counter-area-three">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 order-0 order-lg-2">
            <div className="counter-item-wrap-three">
              <ul className="list-wrap">
                {counter_items.map((x, index) => (
                  <li key={index}>
                    <CounterAreaThreeItem item={x} />
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="counter-content-three">
              <div className="section-title title-style-two mb-30">
                <h2 className="title">
                  Vernu Stoffering: Vakmanschap, Duurzaamheid en Maatwerk
                </h2>
              </div>
              <p>
                Met passie voor ambacht en oog voor detail geven wij meubels een
                tweede leven. Onze ervaring en toewijding zorgen voor hoogwaardige
                herstoffering en maatwerkoplossingen voor zowel particuliere als
                zakelijke klanten.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterAreaThree;
